import React from 'react'
import { RangePicker as ReactRangePicker } from 'react-trip-date'
import { Box, FormControl } from '@mui/material'
import moment from 'moment'

import { MoveInStepProps } from '../types'

const MoveInStep: React.FC<MoveInStepProps> = ({ value, onChange, error }) => {
  const handleDateChange = (selectedDays: { from: string; to: string }) => {
    if (selectedDays?.from) {
      onChange(moment(selectedDays.from).format('YYYY-MM-DD'))
    } else {
      onChange('')
    }
  }

  // Prepare selectedDays prop, only pass when value is valid
  const selectedDaysProps = value
    ? {
        selectedDays: { from: value, to: value },
      }
    : {}

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h2 className="text-lg font-bold text-[#1d2129] leading-snug">2. 您计划什么时候入住？</h2>
        <p className="text-sm text-gray-500 font-normal">请选择您期望的入住日期</p>
      </div>

      <FormControl component="fieldset" error={error} fullWidth>
        <Box className="flex justify-center p-4 bg-white">
          <ReactRangePicker
            onChange={handleDateChange}
            {...selectedDaysProps}
            numberOfMonths={1}
            disabledBeforeToday
            autoResponsive={false}
          />
        </Box>
      </FormControl>

      {error && !value && <p className="text-red-500 text-sm font-medium">此问题为必填项</p>}
    </div>
  )
}

export default MoveInStep
